<div
    class="tw-bg-[#0A0A75] tw-text-white tw-flex tw-flex-col md:tw-flex-row tw-items-center tw-justify-between tw-gap-10 tw-relative tw-pt-8 md:tw-pt-4 tw-h-[442px] md:tw-h-[365px]"
>
    <!-- Left Content -->
    <div
        class="tw-text-center sm:tw-text-left tw-relative tw-z-10 md:tw-w-[40%] tw-px-6 lg:tw-pl-20 lg:tw-pr-3"
    >
        <p
            class="tw-w-full tw-text-[26px] md:tw-text-[38px] tw-text-white tw-font-bold tw-leading-[100%] lg:tw-leading-[47px]"
        >
            {{ bannerTitle }}
        </p>
        <p
            class="!tw-text-[13px] tw-mb-6 tw-font-normal tw-leading-[141%] lg:tw-leading-[22px]"
            [innerHTML]="bannerDesc"
        >
        </p>
    </div>

    <!-- Right Content -->
    <div
        class="tw-w-full md:tw-w-[60%] tw-flex tw-flex-col md:tw-h-full md:tw-justify-end"
    >
        <img
            src="{{ bannerMobileImageURL }}"
            alt="Business Financing"
            class="tw-w-full tw-h-auto tw-max-h-[350px] lg:tw-max-h-[500px] md:tw-hidden"
        />
        <img
            src="{{ bannerImageURL }}"
            alt="Business Financing"
            class="tw-w-fit tw-h-auto tw-hidden md:tw-block md:tw-self-end md:tw-h-full md:tw-object-contain md:tw-object-bottom"
        />
    </div>
</div>
